import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { DoughnutComponent } from '@shared/components/charts/doughnut/doughnut.component';
import { AddMoreResourcesModalComponent } from '@shared/modules/account/modals/add-more-resources-modal/add-more-resources-modal.component';

@Component({
  selector: 'app-add-more-resources-card',
  templateUrl: './add-more-resources-card.component.html',
  styleUrls: ['./add-more-resources-card.component.scss']
})
export class AddMoreResourcesCardComponent {

  @ViewChild(DoughnutComponent) doughnutChart?: DoughnutComponent;

  @Input() resource!: string;
  @Input() currentCount!: number;
  @Input() priceForOneUnit!: number;
  @Input() totalCount!: number;
  @Input() totalLimit!: number;
  @Input() renewalDate: Date | null = null;
  @Input() currency!: string;
  @Input() doughnutHeight = 140;
  @Input() doughnutWidth = 140;
  @Input() isActive = false;

  @Input() title: string = "";
  @Input() description: string = "";
  @Input() button: string = "";

  @Input() chartColors: string[];
  @Input() chartData: Array<{ name: string, value: number }>;
  @Input() descriptionText: string;

  @Output() clickedAddMoreResources = new EventEmitter();

  constructor(
    private dialogService: NbDialogService
  ) { }

  protected get chartDescriptionText(): string {
    return this.descriptionText || `${this.currentCount}/${this.totalCount}`;
  }
  
  ngOnChanges(): void {
    if (this.doughnutChart) {
      this.doughnutChart.updateDoughnut(this.getChartData(), this.chartDescriptionText);
    }
  }

  getChartData(): Array<{ name: string, value: number }> {
    return this.chartData || [
      {
        name: "",
        value: this.currentCount
      },
      {
        name: "",
        value: Math.max(0, this.totalCount - this.currentCount)
      }
    ];
  }

  addMoreResources(title?: string) {
    this.clickedAddMoreResources.emit();

    this.dialogService.open<any>(AddMoreResourcesModalComponent, {
      context: {
        resource: this.resource,
        currentCount: this.currentCount,
        priceForOneUnit: this.priceForOneUnit,
        totalCount: this.totalCount,
        totalLimit: this.totalLimit,
        title: title || this.button,
        currency: this.currency,
        isActive: this.isActive
      }
    });
  }

}
